import { createFileRoute } from "@tanstack/react-router";

import { SupportConfirmationScreen } from "@/modules/support/screens/SupportConfirmationScreen";

export const Route = createFileRoute("/support/confirmation")({
  component: SupportConfirmationScreen,
});
